/**
 * @file: This file holds the rule that two interval times must obey.
 *
 * The calendar panel and the server both check the times before a save. The
 * rule is here, so both give the same answer and the same sentence.
 */

/**
 * The reason to refuse the two times, as a sentence for the operator.
 *
 * Any length is valid. A base loop of 24 hours or more is a valid plan.
 *
 * @param {Object} start - A moment
 * @param {Object} end - A moment
 * @returns {string|null} null when the times are usable
 */
function intervalTimesProblem (start, end) {
  if (!start.isValid()) {
    return 'The start time of the interval cannot be read.'
  }
  if (!end.isValid()) {
    return 'The end time of the interval cannot be read.'
  }
  // The database keeps whole seconds, so two times in the same second are equal there.
  if (!end.isAfter(start, 'second')) {
    return 'The interval must end after it starts.'
  }
  return null
}

export { intervalTimesProblem }
